import { getDefaultPath } from '../../helpers/urlSync';
import actions, { getView } from './actions';

const preKeys = getDefaultPath();

const DEFAULT_ACCENT = "#002a49";
// Force reset to new default if still on old red default
const stored = localStorage.getItem("accentColor");
if (stored === "#f44336" || stored === "#e03400" || stored === "#e53935") {
  localStorage.removeItem("accentColor");
}
const storedAccent = localStorage.getItem("accentColor") || DEFAULT_ACCENT;
// Apply stored accent color immediately on load
document.documentElement.style.setProperty("--accent-color", storedAccent);

const initState = {
  collapsed: window.innerWidth > 1220 ? false : true,
  view: getView(window.innerWidth),
  height: window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  accentColor: storedAccent,
};
export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return { ...state, collapsed: !state.collapsed };
    case actions.COLLPSE_OPEN_DRAWER:
      return { ...state, openDrawer: !state.openDrawer };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height: height
        };
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return { ...state, openKeys: action.openKeys };
    case actions.CHANGE_CURRENT:
      return { ...state, current: action.current };
    case actions.CLOSE_ALL:
      return { ...state, current: [], openKeys: [] };
    case actions.CHANGE_ACCENT_COLOR:
      localStorage.setItem("accentColor", action.color);
      document.documentElement.style.setProperty("--accent-color", action.color);
      return { ...state, accentColor: action.color };
    default:
      return state;
  }
  return state;
}
